import Dexie from "dexie";
import { IDatabaseUpgrade } from "../database-upgrade";

/**
 * Defines the upgrade path for version 6 of indexed DB.
 */
export class DatabaseUpgradeV6 implements IDatabaseUpgrade {
	/** @inheritdoc */
	public readonly Version: number = 6;

	/** @inheritdoc */
	public Upgrade(dexieInstance: Dexie): void {
		dexieInstance.version(this.Version).stores({
			DefaultRoutingDepotAddresses: "Id, UserName",
			DispatchServiceCapturedBinaryDataFragments : "Id, UserName",
			DispatchedServiceSyncData: "Id, UserName, CrownId, LegacyId",
			GpsPoints: "Id, UserName, CrownId"
		});
	}
}